import { useEffect, useState } from 'react';
import StudentDashboard from './student/StudentDashboard';
import LoginScreen from './auth/LoginScreen';
import SetupScreen from './auth/SetupScreen';
import TeacherDashboard from './teacher/TeacherDashboard';
import AdminDashboard from './admin/AdminDashboard';
import MaterialsDashboard from './admin/MaterialsDashboard';
import { logout, me, setToken } from './lib/api';

type Role = 'student' | 'teacher' | 'admin';

export default function App() {
  const [role, setRole] = useState<Role | null>(null);
  const setupMode = window.location.pathname.replace(/\/+$/, '') === '/setup' || new URLSearchParams(window.location.search).get('setup') === '1';
  const [adminMaterials, setAdminMaterials] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    me().then((actor) => setRole(actor.role)).catch(() => setToken(null)).finally(() => setChecking(false));
  }, []);

  if (checking && !setupMode) return <main className="loading-shell"><span className="eyebrow">TALKUP</span><h1>Preparing your workspace…</h1></main>;
  if (setupMode) return <SetupScreen />;
  if (!role) return <LoginScreen onAuthenticated={setRole} />;
  if (role === 'admin') return adminMaterials
    ? <MaterialsDashboard onBack={() => setAdminMaterials(false)} />
    : <AdminDashboard onLogout={() => setRole(null)} onOpenMaterials={() => setAdminMaterials(true)} />;
  if (role === 'teacher') return <TeacherDashboard onLogout={() => setRole(null)} />;

  return <div className="app-with-session">
    <button className="session-signout" onClick={async () => { await logout(); setRole(null); }}>Sign out</button>
    <StudentDashboard />
  </div>;
}
